// extracted by mini-css-extract-plugin
export default {"cls1":"SimplePaperPodcast-cls1___3665025d179367dacf8","cls2":"SimplePaperPodcast-cls2__c11556e939492ce788a2 SimplePaperPodcast-cls1___3665025d179367dacf8"};